
import Organization from '../svgs/delivery/organization.svg'
import Setting from '../svgs/delivery/setting.svg'
import Reset from '../svgs/delivery/reset.svg'
import Admin from '../svgs/relatedServices/locationAdmin.svg'

export const benefitList = [
  {
    subtitle: 'cases.development.title',
    subdescription: 'cases.development.description',
    img: Setting,
  },
  {
    subtitle: 'cases.control.title',
    subdescription: 'cases.control.description',
    img: Organization
  },
  {
    subtitle: 'cases.security.title',
    subdescription: 'cases.security.description',
    img: Reset,
  },

]

export const relatedServices = [
  {
    title: 'Location Admin',
    img: Admin,
    link: '/location-admin'
  }
];
